export const getSpErrorMsg = (e) =>
    e.shpError && e.shpError.get_message ? e.shpError.get_message() : e.message;
